<div class="main-body">
  <app-select-group
    class="main-body"
    [itemList]="colorSelectableList"
    [selectionMode]="SelectGroupMode.single"
    (itemChange)="onItemChange($event)"
  >
    <ng-template let-item>
      <app-color-selector-item [colorSelectable]="item"></app-color-selector-item>
    </ng-template>
  </app-select-group>
</div>
